import { faArrowLeft, faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";

import LinkButton from "common/components/LinkButton";
import Icon from "common/components/Icon";

import PillButton from "../buttons/PillButton";
import Logo from "./Logo";

import styles from "../../styles/StreamlinedHeader.module.less";

type StreamlinedHeaderProps = {
  hasLogo?: boolean;
  hasPrevious?: boolean;
  onPrevious?: () => void;
  onHelp?: () => void;
  renderHelp?: (props: StreamlinedHeaderProps) => React.ReactNode;
};

const defaultRenderHelp = ({ onHelp }: StreamlinedHeaderProps) => {
  return (
    onHelp && (
      <PillButton onClick={onHelp} className={styles.button} variant="secondary" size="s">
        <div className={styles.label}>
          Help
          <Icon icon={faQuestionCircle} className={styles.icon} />
        </div>
      </PillButton>
    )
  );
};

const StreamlinedHeader = (props: StreamlinedHeaderProps) => {
  const {
    hasLogo = true,
    hasPrevious = true,
    onPrevious = () => window?.history?.back(),
    renderHelp = defaultRenderHelp,
    onHelp,
  } = props;

  return (
    <div className={styles.header}>
      <div className={styles.content}>
        <div className={styles.left}>
          {hasPrevious && (
            <LinkButton className={styles.back} onClick={onPrevious}>
              <Icon icon={faArrowLeft} className={styles.icon} />
            </LinkButton>
          )}
        </div>
        <div className={styles.center}>{hasLogo && <Logo />}</div>
        <div className={styles.help}>{onHelp && renderHelp(props)}</div>
      </div>
    </div>
  );
};

export default StreamlinedHeader;
